/**
 * Central registry of TanStack Query keys.
 *
 * Keeping them in one place is what makes invalidation predictable: a mutation
 * can invalidate a whole domain without knowing which components are mounted.
 */
export const queryKeys = {
  me: ["me"] as const,
  health: ["ops", "health"] as const,

  dashboard: {
    stats: (days: number) => ["dashboard", "stats", days] as const,
    timeseries: (days: number) => ["dashboard", "timeseries", days] as const,
  },

  licenses: {
    all: ["licenses"] as const,
    products: ["product-catalog"] as const,
    list: (params?: unknown) => ["licenses", "list", params] as const,
    detail: (id: number | string) => ["licenses", "detail", String(id)] as const,
    stats: (id: number | string) => ["licenses", "detail", String(id), "stats"] as const,
    history: (id: number | string, params?: unknown) =>
      ["licenses", "detail", String(id), "history", params] as const,
  },

  roles: {
    all: ["roles"] as const,
    list: (params?: unknown) => ["roles", "list", params] as const,
  },

  targets: {
    all: ["darkweb-targets"] as const,
    list: (params?: unknown) => ["darkweb-targets", "list", params] as const,
  },

  history: {
    all: ["license-history"] as const,
    list: (params?: unknown) => ["license-history", "list", params] as const,
  },

  blacklists: {
    all: (kind: "ip" | "mac") => [`${kind}-blacklist`] as const,
    list: (kind: "ip" | "mac", params?: unknown) =>
      [`${kind}-blacklist`, "list", params] as const,
  },

  revocations: {
    all: ["revocations"] as const,
    list: (params?: unknown) => ["revocations", "list", params] as const,
  },

  tickets: {
    all: ["tickets"] as const,
    list: (params?: unknown) => ["tickets", "list", params] as const,
    detail: (id: string) => ["tickets", "detail", id] as const,
    messages: (id: string) => ["tickets", "detail", id, "messages"] as const,
  },

  cannedReplies: {
    all: ["canned-replies"] as const,
    list: (params?: unknown) => ["canned-replies", "list", params] as const,
  },

  customers: {
    all: ["customers"] as const,
    list: (params?: unknown) => ["customers", "list", params] as const,
  },

  blogs: {
    all: ["blogs"] as const,
    list: (params?: unknown) => ["blogs", "list", params] as const,
    detail: (id: string) => ["blogs", "detail", id] as const,
  },

  contacts: {
    all: ["contacts"] as const,
    list: (params?: unknown) => ["contacts", "list", params] as const,
  },

  users: {
    all: ["users"] as const,
    list: (params?: unknown) => ["users", "list", params] as const,
  },

  settings: {
    constance: ["settings", "constance"] as const,
  },

  tasks: {
    all: ["tasks"] as const,
    list: (params?: unknown) => ["tasks", "list", params] as const,
  },
} as const;
